<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> factor de ponderación <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content>
      <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre" [disabled]="action == 'View'">
      </mat-form-field>
          <!-- CONTENT CARD -->
          <div class="content-card" *ngIf="action != 'Delete'">

              <!-- CONTENT TOOLBAR -->
              <div class="toolbar px-24 py-8">
                  <span>Categorías</span>
              </div>
              <!-- / CONTENT TOOLBAR -->

              <!-- CONTENT -->
              <div class="content p-24" fxLayout="column">

                <div fxLayout="row" fxFlex="100">
                  <mat-form-field *ngIf="action != 'Delete' && action != 'View'" fxFlex="60" class="select-edit px-10">
                    <input placeholder="Nombre" matInput [(ngModel)]="new_line.descripcion" >
                  </mat-form-field>
                  <mat-form-field *ngIf="action != 'Delete' && action != 'View'" fxFlex="20" class="select-edit px-10">
                    <input placeholder="Porcentaje" matInput [(ngModel)]="new_line.porcentaje" type="number" step="any">
                  </mat-form-field>
                  <!--<mat-form-field *ngIf="action != 'Delete'" class=".select-edit">
                    <input placeholder="Factor" matInput [(ngModel)]="new_line.factor" type="number" step="any">
                  </mat-form-field>-->
                  <button mat-button (click)="addLine()" mat-flat-button color="primary" class="add-row" *ngIf="action != 'Delete' && action != 'View'">Agregar</button>
                </div>

                  <table mat-table [dataSource]="dataSource" #mytable class="my-table mat-elevation-z8 select-list" >

                    <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                    <!-- User Column -->
                    <ng-container matColumnDef="descripcion">
                      <th mat-header-cell *matHeaderCellDef> Descripcion. </th>
                      <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                    </ng-container>

                    <ng-container matColumnDef="porcentaje">
                      <th mat-header-cell *matHeaderCellDef> Porcentaje. </th>
                      <td mat-cell *matCellDef="let element"> {{element.porcentaje}} </td>
                    </ng-container>

                    <ng-container matColumnDef="factor">
                      <th mat-header-cell *matHeaderCellDef> Factor. </th>
                      <td mat-cell *matCellDef="let element"> {{element.factor}} </td>
                    </ng-container>


                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef> Acción </th>
                      <td mat-cell *matCellDef="let element" class="action-link">
                        <a (click)="edit(element)" *ngIf="action != 'Delete' && action != 'View'">Editar</a>
                        <span *ngIf="action != 'Delete' && action != 'View'"> | </span>
                        <a (click)="remove(element)" *ngIf="action != 'Delete' && action != 'View'">Eliminar</a>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>

              </div>
              <!-- / CONTENT -->

          </div>
          <!-- / CONTENT CARD -->



</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" *ngIf="action != 'View'">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
